import { type ReactNode } from 'react';
import ContentDivider from '@common/components/ContentDivider';
import classnames from '@common/utils/ui/classnames';
import '@common/styles/components/list.pcss';

interface NewListItemProps {
  children: ReactNode;
  id: string;
  deleting?: boolean;
  noDivider?: boolean;
}

function SimpleListItem({
  children,
  id,
  deleting,
  noDivider,
}: Readonly<NewListItemProps>) {
  return (
    <li
      data-id={id}
      className={classnames({
        list__option: true,
        'txt-small': true,
        'list__option--deleting': deleting,
      })}
    >
      <div className="list__option-wrapper">
        {children}
      </div>
      {!noDivider && <ContentDivider deleting={deleting} mt={0} mb={0} />}
    </li>
  );
}

export default SimpleListItem;
